import React, { useState, useMemo } from "react";
import { matchPath, useLocation, useNavigate, Outlet } from "react-router-dom";
import { BoxIcons, IconTypes } from "us.icons";
import { ConnectedProps, connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Header } from "../Header";
import Common from "us.common";
import { getSelectedMenuKeyByModule } from "us.collection/functions";
import { RootState } from "us.helper/types";
import { INavigationData } from "us.collection/interfaces";

const { $Layout, $Menu } = Common.Components;

const TransactionLayout: React.FC<PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const navigateTo = useNavigate();
  const location = useLocation();
  const state = location.state as INavigationData;
  const pathname = location.pathname;
  const params: { type: string; id: string; module: string } = useMemo(() => {
    const { params }: any = matchPath(
      {
        path: "/:type/:id?/:module?",
        end: false,
        caseSensitive: false,
      },
      pathname
    );
    return {
      type: params["type"] ?? "",
      id: params["id"] ?? "",
      module: params["module"] ?? "",
    };
  }, [pathname]);

  const { Content, Sider } = $Layout;

  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  const navigate = (url: string): void => {
    window.scrollTo(0, 0);
    navigateTo(
      {
        ...location,
        pathname: `/payment/${params?.id}/${url}`,
      },
      { state }
    );
  };

  return (
    <$Layout style={{ minHeight: "100vh" }}>
      <Header />
      <$Layout>
        <Content style={{ margin: "0" }}>
          <Outlet />
        </Content>
        <Sider
          collapsible
          collapsed={isCollapsed}
          onCollapse={(collapsed) => setIsCollapsed(collapsed)}
          reverseArrow={true}
        >
          <$Menu
            theme="dark"
            selectedKeys={getSelectedMenuKeyByModule(params["module"])}
            mode="inline"
          >
            <$Menu.Item onClick={() => navigate("history")} key="16">
              <BoxIcons type={IconTypes.BOX_ICON} name="activity-history" />
              <span>{t("US.COLLECTION.LAYOUT:CASE.HISTORY")}</span>
            </$Menu.Item>

            <$Menu.Item onClick={() => navigate("distribution")} key="3">
              <BoxIcons type={IconTypes.BOX_ICON} name="payment-distribution" />
              <span>
                {t(
                  "US.COLLECTION.TRANSACTIONS:PAYMENTDISTRIBUTION.PAYMENTDISTRIBUTION"
                )}
              </span>
            </$Menu.Item>
          </$Menu>
        </Sider>
      </$Layout>
    </$Layout>
  );
};

const mapStateToProps = (state: RootState) => {
  const { router } = state;
  const { location } = router;
  const { pathname } = location;
  return {
    locationState: pathname,
  };
};

const connector = connect(mapStateToProps, {});

type PropsFromRedux = ConnectedProps<typeof connector> & {
  children?: React.ReactNode;
};

export default connector(TransactionLayout);
